import * as React from 'react';
import { Activity, Attachment, AttachmentLayout } from 'botframework-directlinejs';
import { AttachmentView } from './Attachment';
import { Carousel } from './Carousel';
import { FormattedText } from './FormattedText';
import { FormatState, SizeState } from './Store';

import { FeedbackView } from './Feedback';
import { EscalationView } from './Escalation';
import { EscalationInfoView } from './EscalationInfo';
import * as ReactDOM from 'react-dom';

import { containsClass } from './utilites';

const Attachments = (props: {
    attachments: Attachment[],
    attachmentLayout: AttachmentLayout,
    format: FormatState,
    size: SizeState,
    onCardAction: (type: string, value: string) => void,
    onImageLoad: () => void
}) => {
    const { attachments, attachmentLayout, ... otherProps } = props;
    if (!attachments || attachments.length === 0)
        return null;
    return attachmentLayout === 'carousel' ?
        <Carousel
            attachments={ attachments }
            { ... otherProps }
        />
    :
        <div className="wc-list">
            { attachments.map((attachment, index) =>
                <AttachmentView
                    key={ index }
                    attachment={ attachment }
                    { ... otherProps }
                />
            ) }
        </div>
}

export interface ActivityViewProps {
    format: FormatState,
    size: SizeState,
    activity: Activity,
    candidates: string[],
    onCardAction: (type: string, value: string) => void,
    sendMessage: (inputText: string, channelData:any) => void,
    onImageLoad: () => void,
    options: any,
    store:any
}

export class ActivityView extends React.Component<ActivityViewProps, {}> {
    private dataProps:ActivityViewProps

    constructor(props: ActivityViewProps) {
        super(props)

        this.dataProps = this.props;
    }

    componentWillMount() {
        // フック関数の実行
        if (this.props.options.beforeAnswered &&
            typeof this.props.options.beforeAnswered === "function") {
            const returnData = this.props.options.beforeAnswered({
                props : this.dataProps,
                onCardAction : this.props.onCardAction,
                sendMessage : this.props.sendMessage
            });

            this.dataProps = returnData.props;
        }
    }

    shouldComponentUpdate(nextProps: ActivityViewProps) {
        if (this.dataProps.activity !== nextProps.activity) {
           this.dataProps = nextProps;
        }

        // if the activity changed, re-render
        return this.props.activity !== nextProps.activity
        // if the format changed, re-render
            || this.props.format !== nextProps.format
        // if it's a carousel and the size changed, re-render
            || (this.props.activity.type === 'message'
                && this.props.activity.attachmentLayout === 'carousel'
                && this.props.size !== nextProps.size);
    }

    componentDidMount() {
        let activityiew = this;
        setTimeout(() => {
            let elems = ReactDOM.findDOMNode(activityiew).getElementsByClassName('osk-btn');
            for (var i = 0; i < elems.length; ++i) {
                let elem = elems.item(i);

                let command = elem.getAttribute("data-command");
                if (!command || command.indexOf('imBack') !== 0) {
                    continue;
                }

                let btn = elem as HTMLButtonElement;
                btn.setAttribute('type', 'button');
                btn.onclick = () => {
                    this.props.onCardAction('imBack', btn.value);
                };
            }
        }, 0);

        setTimeout(() => {
            // エンデカ検索用のリスト調整
            let maxList = this.props.options.linkListLimit;
            let elems = ReactDOM.findDOMNode(activityiew).getElementsByTagName('dl');
            let historyActivities = this.props.store.getState().history.activities;
            let inputText = (historyActivities.length > 2) ?
                historyActivities[historyActivities.length - 2].text : '';

            for (var i = 0; i < elems.length; ++i) {
                let dl = elems.item(i);
                if (!containsClass(dl, 'endeca')) {
                    continue;
                }

                // リンクが1件も見つからなかった場合
                if (dl.childElementCount === 0) {
                    dl.appendChild(dl.ownerDocument.createTextNode('ご質問に近いページが見つかりませんでした。'));
                    dl.appendChild(dl.ownerDocument.createElement('br'));
                    dl.appendChild(dl.ownerDocument.createTextNode('恐れ入りますが他の言い方でご質問ください。'));
                    continue;
                }

                let dts = dl.getElementsByTagName('dt');

                if (dts.length <= maxList) continue;

                // 指定件数を超える場合は超えた要素を消してボタンを表示する

                for (let ii = maxList, len = dts.length; ii < len; ii++) {
                    let removeElem = dts[maxList].nextElementSibling;
                    if (removeElem.tagName.toLowerCase() === 'dd') {
                        removeElem.parentNode.removeChild(removeElem);
                        dts[maxList].parentNode.removeChild(dts[maxList]);
                    }
                }

                let btnWrap = dl.ownerDocument.createElement('p');
                let btn = dl.ownerDocument.createElement('a');
                btnWrap.className = 'osk-show-dl';
                btn.href = 'https://search.otsuka-shokai.co.jp/?kw=' + encodeURIComponent(inputText) + '&ie=s&la=ja&suggest=1';
                btn.target = '_blank';
                btn.appendChild(dl.ownerDocument.createTextNode('全ての検索結果を見る'));
                btnWrap.appendChild(btn);
                dl.parentNode.insertBefore(btnWrap, dl.nextElementSibling);
            }
        }, 0);

        setTimeout(() => {
            // FAQ検索用のリスト調整
            let elems = ReactDOM.findDOMNode(activityiew).getElementsByTagName('dl');

            for (var i = 0; i < elems.length; ++i) {
                let dl = elems.item(i);
                if (!containsClass(dl, 'faq-search')) {
                    continue;
                }
                let textParam = dl.getAttribute('data-faq-text');
                let categoryParam = dl.getAttribute('data-faq-category');

                // リンクが1件も見つからなかった場合
                if (dl.childElementCount === 0) {
                    dl.appendChild(dl.ownerDocument.createTextNode('ご質問に近いページが見つかりませんでした。'));
                    dl.appendChild(dl.ownerDocument.createElement('br'));
                    dl.appendChild(dl.ownerDocument.createTextNode('恐れ入りますが他の言い方でご質問ください。'));
                    continue;
                }

                let btnWrap = dl.ownerDocument.createElement('p');
                let btn = dl.ownerDocument.createElement('a');
                btnWrap.className = 'osk-show-dl';
                btn.href = 'https://faq.mypage.otsuka-shokai.co.jp/app/answers/list/st/4/kw/' + textParam + '/p/' + categoryParam + '/page/1/ao/1/pp/10';
                btn.target = '_blank';
                btn.appendChild(dl.ownerDocument.createTextNode('全ての検索結果を見る'));
                btnWrap.appendChild(btn);
                dl.parentNode.insertBefore(btnWrap, dl.nextElementSibling);
            }
        }, 0);

    }

    render() {
        const { activity, ... otherProps } = this.props;

        //const evalMode = (this.props.options) ? this.props.options.eval : false;
        //const evalMode = true;

        switch (this.dataProps.activity.type) {
            case 'message':

                return (
                    <div className="chat-main">
                        <FormattedText
                            text={ this.dataProps.activity.text }
                            format={ this.dataProps.activity.textFormat }
                            onImageLoad={ otherProps.onImageLoad }
                        />
                        <Attachments
                            attachments={ this.dataProps.activity.attachments }
                            attachmentLayout={ this.dataProps.activity.attachmentLayout }
                            { ... otherProps }
                        />
                        { this.dataProps.options.feedbackMode !== ""?
                        <FeedbackView
                            message={ this.dataProps.activity }
                            feedbackMode={ this.dataProps.options.feedbackMode }
                            candidates={ this.props.candidates }
                            onShow={ () => { otherProps.onImageLoad(); } }
                            onCardAction={ otherProps.onCardAction }
                            userDefined={ this.props.options.feedbackUserDefined || {} }
                        />
                        : null }
                        <EscalationView
                            message={ this.dataProps.activity }
                            candidates={ this.props.candidates }
                            onShow={ () => { otherProps.onImageLoad(); } }
                            onCardAction={ otherProps.onCardAction }
                            options={ this.props.options }
                        />
                        <EscalationInfoView
                            message={ this.dataProps.activity }
                            candidates={ this.props.candidates }
                            onShow={ () => { otherProps.onImageLoad(); } }
                            onCardAction={ otherProps.onCardAction }
                        />
                    </div>
                );

            case 'typing':
                return <div className="wc-typing"/>;
        }
    }
}


// WEBPACK FOOTER //
// ./src/ActivityView.tsx